import { Box } from "@mui/material";
import { EcoEfficiencyProvider } from "../../../contexts/EcoEfficiencyContext";
import Layout from "../../../layouts";
import { EcoEfficiencyDataGrid } from "./EcoEfficiencyDataGrid";
import { EcoEfficiencyTabMenuV2 } from "../_components/EcoEfficiencyTabMenu";

export type displayType = "table" | "chart";

export const EcoEfficiency = () => {
  return (
    <EcoEfficiencyProvider>
      <Layout>
        <Box
          display={"flex"}
          flexDirection={"column"}
          flex={1}
          height={"100%"}
          color={"var(--dark)"}
          minHeight={0}
        >
          <EcoEfficiencyTabMenuV2 />

          <Box
            px={"40px"}
            pb={"40px"}
            pt={"32px"}
            flex={1}
            minHeight={0}
            bgcolor={"var(--white)"}
          >
            <EcoEfficiencyDataGrid />
          </Box>
        </Box>
      </Layout>
    </EcoEfficiencyProvider>
  );
};
